module.exports = __webpack_public_path__ + "static/media/keyvisual_login_tiny.ca5dfc25.jpg";